import React, { useEffect, useState } from 'react';
import { AlertTriangle, TrendingDown, ChevronDown, ChevronUp } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const LVL = { alto: 'border-red-500/50 bg-red-500/10 text-red-300', medio: 'border-amber-500/50 bg-amber-500/10 text-amber-200', bajo: 'border-emerald-500/40 bg-emerald-500/5 text-emerald-300' };

const Spark = ({ hist }) => {
  if (!hist || hist.length < 2) return null;
  const pts = hist.map((h, i) => `${(i / (hist.length - 1)) * 60},${20 - h.p * 20}`).join(' ');
  return <svg width="60" height="20" className="shrink-0"><polyline points={pts} fill="none" stroke="currentColor" strokeWidth="1.5" /></svg>;
};

// Portfolio risk: win probability per case and the reasons a case is at risk
export const PortfolioRiskPanel = () => {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  useEffect(() => { api.get('/cerebro/portfolio-risk').then((r) => setData(r.data)).catch(() => {}); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!data?.matters?.length) return null;
  const risky = data.matters.filter((m) => m.risk_level !== 'bajo');
  return (
    <section data-testid="portfolio-risk-panel" className="mb-8 rounded-2xl border border-slate-800 bg-slate-900/60 p-5">
      <button onClick={() => setOpen(!open)} className="flex w-full flex-wrap items-center justify-between gap-2" data-testid="portfolio-risk-toggle">
        <h2 className="flex items-center gap-2 text-sm font-semibold"><AlertTriangle className="h-4 w-4 text-red-400" />Riesgo de la cartera</h2>
        <div className="flex flex-wrap items-center gap-2 text-xs">
          {['alto', 'medio', 'bajo'].map((l) => <span key={l} data-testid={`portfolio-risk-count-${l}`} className={`rounded-full border px-2 py-0.5 ${LVL[l]}`}>{data.summary[l]} {l}</span>)}
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </div>
      </button>
      {open && (
        <div className="mt-4 grid min-w-0 gap-2 md:grid-cols-2">
          {(risky.length ? risky : data.matters.slice(0, 4)).slice(0, 8).map((m) => (
            <div key={m.matter_id} data-testid={`portfolio-risk-item-${m.matter_id}`} className={`min-w-0 rounded-xl border p-3 ${LVL[m.risk_level]}`}>
              <div className="flex min-w-0 items-center justify-between gap-2">
                <p className="min-w-0 truncate text-sm font-semibold text-white">{m.title}</p>
                <div className="flex items-center gap-2"><Spark hist={m.history} /><span className="text-sm font-bold">{m.probability == null ? '—' : `${Math.round(m.probability * 100)}%`}</span></div>
              </div>
              <p className="text-[11px] capitalize text-slate-400">{m.country} · {m.matter_type} · riesgo {m.risk_level}</p>
              {m.factors.map((f, i) => <p key={i} className="text-xs text-slate-200 flex gap-1">{f.startsWith('Probabilidad') && <TrendingDown className="h-3 w-3 mt-0.5" />}• {f}</p>)}
            </div>
          ))}
        </div>
      )}
      <p className="mt-3 text-[10px] text-slate-500">{data.disclaimer}</p>
    </section>
  );
};
